module.exports = __webpack_public_path__ + "img/zone5.1336092e.png";